import React, { useState } from 'react'
import DataGridSkeleton from '../../shared/components/DataGridSkeleton';
import { DataGrid } from '@mui/x-data-grid';
import CustomPagination from '../../shared/utils/CustomPagination';
import { Typography } from '@mui/material';

const EventListTable  = ({ eventRow, isLoading }) => {
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const eventColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "event_fees",
            headerName: "Event Fees",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "start_date",
            headerName: "Start Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "end_date",
            headerName: "End Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        // {
        //     field: "start_time",
        //     headerName: "Start Time",
        //     flex: 1,
        //     renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        // },
        // {
        //     field: "end_time",
        //     headerName: "End Time",
        //     flex: 1,
        //     renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        // },
    ];
    return (
        <>

            {isLoading ? (
                <DataGridSkeleton rowsNum={10} />
            ) : (
                <DataGrid
                    rows={eventRow}
                    columns={eventColumns}
                    pagination
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[10]}
                    disableRowSelectionOnClick={true}
                    slots={{
                        pagination: () => (
                            <CustomPagination
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                totalRows={eventRow?.length || 0}
                                pageSize={paginationModel.pageSize}
                            />
                        ),
                    }}
                />
            )}
        </>
    )
}

export default React.memo(EventListTable);